import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink, Link } from "react-router-dom";
import {
  SERVICE_LINK,
  CMSINDEX_LINK,
  ADMIN_INDEX_LINK,
  LOGIN_LINK,
  MY_LINK,
  TODO_LINK,
  DASHBOARD_LINK,
  LOG_OUT_URL
} from "../actions/types";
import httpRequest from "../apis/httpRequest";
import Icon from "antd/lib/icon";
import PropTypes from "prop-types";
import userImg from "../images/DefaultAvatarGafa.png";
import defaultImg from "../images/myImgGafa.png";
import tipsImg from "../images/tips.png";
import noticeImg from "../images/noticeImg.png";
import { checkAuth } from "actions/index";
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showNotice: false,
      showPerOpt: false
    };
    this.tipsToggle = React.createRef();
    this.userinfoToggle = React.createRef();
    this.onClickOutsideHandler = this.onClickOutsideHandler.bind(this);
  }
  componentDidMount() {
    window.addEventListener("scroll", this.orderScroll.bind(this));
    window.addEventListener("click", this.onClickOutsideHandler);
    this.props.checkAuth();
    setInterval(() => {
      this.props.checkAuth();
    }, 5 * 60 * 1000);
  }
  logout = () => {
    httpRequest
      .get(LOG_OUT_URL)
      .then(function (res) {
        window.location.replace(res.data.payload);
      })
      .catch(err => {
        console.log("err:", err);
      });
    this.setState({ showNotice: false, showPerOpt: false });
  };
  orderScroll(eve) {
    // alert(document.documentElement.clientHeight);//网页可见区域宽
    // alert(window.screen.height);//屏幕分辨率的高
    // document.write(window.screen.height);
    if (window.scrollY <= 40) {
      document
        .getElementsByClassName("App-header")[0]
        .classList.remove("gafa-background");
    } else {
      document
        .getElementsByClassName("App-header")[0]
        .classList.add("gafa-background");
    }
  }
  onClickOutsideHandler(event) {
    if (
      this.state.showNotice &&
      this.tipsToggle.current &&
      !this.tipsToggle.current.contains(event.target)
    ) {
      this.setState({ showNotice: false });
    }
    if (
      this.state.showPerOpt &&
      this.userinfoToggle.current &&
      !this.userinfoToggle.current.contains(event.target)
    ) {
      this.setState({ showPerOpt: false });
    }
  }
  render() {
    return (
      <div className="header-section">
        <header className="App-header">
          <div className="row">
            <div className="logo">
              <Link to={DASHBOARD_LINK}>logo</Link>
            </div>
            {this.renderPCNav()}
            {this.renderPerInfo()}
          </div>
        </header>
        <div className="header-bg" />
      </div>
    );
  }
  // pc端的导航
  renderPCNav() {
    if (this.props.auth.user) {
      return (
        <div className="navPC-list">
          {/* (
            <NavLink exact to={BASE_LINK} activeClassName="active">
              首页
            </NavLink>
          )*/}
          <NavLink to={DASHBOARD_LINK} activeClassName="active">
            服务中心
          </NavLink>
          <NavLink to={SERVICE_LINK} activeClassName="active">
            应用中心
          </NavLink>
          <a href="https://fwdt.gzarts.edu.cn/taskcenter/workflow/index" className='blank-link' target="_blank" >
            办事大厅
          </a>
          <NavLink to={CMSINDEX_LINK} activeClassName="active">
            新闻中心
          </NavLink>
          {this.props.auth.user.role === "admin" && (
            <NavLink to={`${ADMIN_INDEX_LINK}`} activeClassName="active">
              管理入口
            </NavLink>
          )}
        </div>
      );
    } else {
      return <div className="navPC-list" />;
    }
  }
  // 渲染个人信息
  renderPerInfo() {
    if (this.props.auth.user) {
      let username = this.props.auth.user.name || "用户";
      let { showNotice, showPerOpt } = this.state;
      return (
        <div className="header-right">
          {false && <span className="user_name">你好，{username}</span>}
          <span ref={this.tipsToggle}>
            <img
              src={tipsImg}
              width="14"
              alt="提示"
              onClick={() =>
                this.setState({ showNotice: !showNotice, showPerOpt: false })
              }
              style={{ display: "none" }}
            />
            {showNotice && this.renderNotice()}
          </span>
          <span className="log-out" ref={this.userinfoToggle}>
            <img
              src={defaultImg}
              width="24"
              alt="个人头像"
              onClick={() =>
                this.setState({ showPerOpt: !showPerOpt, showNotice: false })
              }
            />
            {showPerOpt && this.renderPerOpt()}
          </span>
        </div>
      );
    } else {
      return (
        <div className="header-right">
          <Link to={LOGIN_LINK} className="log-out" style={{ marginRight: 0 }}>
            <img src={userImg} width="24" height="24" alt="登录" />
          </Link>
        </div>
      );
    }
  }
  renderNotice() {
    return (
      <div className="notice">
        <div className="top">
          <span>3 条未读消息</span>
          <span className="btn">全部已读</span>
        </div>
        <div className="list">
          <div className="list-item">
            <div className="list-item-left">
              <img src={noticeImg} alt="notice" width={28} />
            </div>
            <div className="list-item-right">
              <div className="desc">李月来提交了申请</div>
              <div className="date">今天 15:35</div>
            </div>
          </div>
          <div className="list-item">
            <div className="list-item-left">
              <img src={noticeImg} alt="notice" width={28} />
            </div>
            <div className="list-item-right">
              <div className="desc">李月来提交了申请</div>
              <div className="date">今天 15:35</div>
            </div>
          </div>
          <div className="list-item">
            <div className="list-item-left">
              <img src={noticeImg} alt="notice" width={28} />
            </div>
            <div className="list-item-right">
              <div className="desc">李月来提交了申请</div>
              <div className="date">今天 15:35</div>
            </div>
          </div>
          <div className="list-item">
            <div className="list-item-left">
              <img src={noticeImg} alt="notice" width={28} />
            </div>
            <div className="list-item-right">
              <div className="desc">李月来提交了申请</div>
              <div className="date">今天 15:35</div>
            </div>
          </div>
        </div>
        <Link
          to={TODO_LINK}
          className="bottom"
          onClick={() => {
            this.setState({ showNotice: false });
          }}
        >
          <span>查看更多</span>
        </Link>
      </div>
    );
  }
  renderPerOpt() {
    const username = this.props.auth.user.name || "用户";
    return (
      <div className="per-opt">
        <div className="name">{username}</div>
        <div className="opt-list">
          <Link to={MY_LINK} className="opt-list-item">
            <Icon type="user" style={{ marginRight: 2 }} />
            个人信息
          </Link>
          <a
            className="opt-list-item"
            href="http://ucenter.gzarts.edu.cn/gzarts/resetLink.jsp"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon type="edit" style={{ marginRight: 4 }} />
            修改个人信息
          </a>
          <a
            className="opt-list-item"
            href="http://ucenter.gzarts.edu.cn/gzarts/resetPwd.jsp"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon type="edit" style={{ marginRight: 4 }} />
            修改密码
          </a>
          <div className="opt-list-item" onClick={() => this.logout()}>
            <Icon type="logout" style={{ marginRight: 4 }} />
            退出
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { auth } = state;
  return { auth };
}

Header.propTypes = {
  auth: PropTypes.object,
  loginOut: PropTypes.func
};

export default connect(mapStateToProps, { checkAuth })(Header);
